import { render } from "./TestimonialArea.vue?vue&type=template&id=618e2856"
import script from "./TestimonialArea.vue?vue&type=script&lang=js"
export * from "./TestimonialArea.vue?vue&type=script&lang=js"

import "./TestimonialArea.vue?vue&type=style&index=0&id=618e2856&lang=css"

import exportComponent from "C:\\Users\\Urakehn\\Documents\\Developpement\\R42\\EasyProf_landing\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__